import React from 'react';
import { motion } from 'framer-motion';
const StarIcon = () => <svg className="w-4 h-4 text-gold fill-current" viewBox="0 0 20 20" data-id="element-350">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-351" />
  </svg>;
const testimonials = [{
  quote: 'En 3 semanas pasé de 2 llamadas por semana a tener que contratar un segundo equipo. El sistema funciona. Punto.',
  name: 'Carlos M.',
  company: 'Elite Roofing Solutions',
  location: 'Houston, TX',
  badge: '+650% más leads'
}, {
  quote: 'Gastaba $1,200 al mes en HomeAdvisor y cerraba 1 de cada 10. Ahora invierto $800 y cierro 4 de cada 10. Las matemáticas no mienten.',
  name: 'Roberto L.',
  company: 'R&L Roofing Corp',
  location: 'Dallas, TX',
  badge: '40% tasa de cierre'
}, {
  quote: 'Por primera vez en 8 años, mi agenda está llena en enero y febrero. Ya no dependo de las tormentas.',
  name: 'Miguel A.',
  company: 'Aguila Roofing',
  location: 'Phoenix, AZ',
  badge: '12 meses sin parar'
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon border-t border-dark-border" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-heading font-bold text-gold text-center mb-12 md:mb-16" data-id="element-354">
          Lo Que Dicen Los Roofers Que Ya Usan El Sistema
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-355">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-[#0A0A0A] border border-[#151515] rounded-xl p-6 flex flex-col h-full shadow-lg" data-id="element-356">
              <div className="flex gap-1 mb-4" data-id="element-357">
                {[...Array(5)].map((_, i) => <StarIcon key={i} data-id="element-358" />)}
              </div>

              <p className="text-white italic leading-relaxed mb-6 flex-grow" data-id="element-359">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto border-t border-[#151515] pt-4 flex justify-between items-end" data-id="element-360">
                <div data-id="element-361">
                  <p className="text-gold font-bold" data-id="element-362">{testimonial.name}</p>
                  <p className="text-gray-sec text-sm" data-id="element-363">{testimonial.company}</p>
                  <p className="text-gray-sec text-xs mt-1" data-id="element-364">
                    {testimonial.location}
                  </p>
                </div>
                <div className="bg-emerald/10 text-emerald text-xs font-bold px-3 py-1 rounded-full shrink-0" data-id="element-365">
                  {testimonial.badge}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}